export const ON_SCAN_PROGRESS = /* GraphQL */ `
  subscription OnScanProgress($siteId: ID!, $scanId: ID!) {
    onScanProgress(siteId: $siteId, scanId: $scanId) {
      siteId
      scanId
      userId
      status
      progress {
        phase
        pagesDiscovered
        pagesScanned
        currentPage
        estimatedTimeRemaining
        startedAt
        currentTool
        discoveredIssues
        stepDescription
      }
      config {
        siteUrl
        scanTypes
        wcagVersion
        wcagLevel
        pageLimit
        rateLimit
        selectedTools
        pauseAfterCrawl
      }
      startedAt
      completedAt
      trashedAt
      pdfReportUrl
    }
  }
`;

export const ON_SITE_SCANS_UPDATED = /* GraphQL */ `
  subscription OnSiteScansUpdated($siteId: ID!) {
    onSiteScansUpdated(siteId: $siteId) {
      siteId
      scanId
      userId
      status
      progress {
        phase
        pagesDiscovered
        pagesScanned
        currentPage
        estimatedTimeRemaining
        startedAt
        currentTool
        discoveredIssues
        stepDescription
      }
      config {
        siteUrl
        scanTypes
        wcagVersion
        wcagLevel
        pageLimit
        rateLimit
        selectedTools
        pauseAfterCrawl
      }
      startedAt
      completedAt
      trashedAt
      pdfReportUrl
    }
  }
`;

export const ON_SCAN_COMPLETED = /* GraphQL */ `
  subscription OnScanCompleted($siteId: ID!, $scanId: ID!) {
    onScanCompleted(siteId: $siteId, scanId: $scanId) {
      siteId
      scanId
      userId
      status
      progress {
        phase
        pagesDiscovered
        pagesScanned
        currentPage
        estimatedTimeRemaining
        startedAt
        currentTool
        discoveredIssues
        stepDescription
      }
      config {
        siteUrl
        scanTypes
        wcagVersion
        wcagLevel
        pageLimit
        rateLimit
        selectedTools
        pauseAfterCrawl
      }
      startedAt
      completedAt
      trashedAt
      pdfReportUrl
    }
  }
`;
